<template>
  <div class="pod-derigner" v-loading="loading">
    <div class="pod-derigner-head f-b-c">
      <div class="left">Print-On-Demand</div>
      <div class="name f--c">
        <div class="text">Product Name</div>
        <el-input v-model="productName" type="text" placeholder="Please input product name" maxlength="100" show-word-limit />
      </div>
      <div class="right">
        <el-button type="primary" @click="save" :loading="saveLoading">Save</el-button>
        <el-button @click="jumpList">Close</el-button>
      </div>
    </div>
    <div class="derigner-content">
      <div class="derigner-model f--c">
        <div class="model-operation">
          <div v-for="item in operateList" :key="item.name" class="operation-item f-c-c pointer" :class="{ sel: operateSel === item.name }" @click="operateSel = item.name">
            <img :src="item.icon" />
            <div class="text">{{ item.name }}</div>
          </div>
        </div>
        <div v-if="operateSel === 'Version'" class="model-list">
          <el-input v-model="listParams.searchContent" size="small" clearable placeholder="Search for version name" @change="changePage(1)">
            <el-button slot="append" icon="el-icon-search" @click="changePage(1)"></el-button>
          </el-input>
          <div class="list f-b-c">
            <div class="item" v-for="item in modelList" :key="item.id">
              <div class="img pointer" :class="{ sel: item.id === selModel.id }" @click="changeModel(item.id, 'change')">
                <oss-img :width="134" :height="134" :src="item.imageUrl" />
              </div>
              <div class="code">{{ item.modelCode }}</div>
              <el-tooltip effect="dark" :content="item.enName" placement="bottom-start">
                <div class="name ellipsis">{{ item.enName }}</div>
              </el-tooltip>
            </div>
          </div>
          <div class="paging">
            <el-pagination
              :page-size="listParams.pageSize"
              small
              layout="prev, pager, next"
              :total="total"
              @current-change="changePage">
            </el-pagination>
          </div>
        </div>
        <div v-if="operateSel === 'Upload'" class="model-material">
          <photograph :isCompress="false" :page="'pod'" @uploadSuccess="uploadSuccess">
            <div class="upload f-c-c fd-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/icon_add.png" alt="">
              <div>Click to upload</div>
            </div>
          </photograph>
          <div class="meterial">
            <div class="name">Recently uploaded</div>
            <div v-if="materialList.length" class="list f-b-c">
              <div v-for="t in materialList" :key="t.id" class="item">
                <img :src="t.imageUrl" alt="">
                <div class="operate f-c-c">
                  <el-tooltip effect="dark" content="Delete" placement="top">
                    <img src="https://img.kakaclo.com/web-img/home/pod/derigner/icon_3.png" alt="" class="pointer" @click="handleDelMaterial(t)" />
                  </el-tooltip>
                  <el-tooltip effect="dark" content="Addition" placement="top">
                    <img src="https://img.kakaclo.com/web-img/home/pod/derigner/icon_4.png" alt="" class="pointer" @click="handleAdd(t)" />
                  </el-tooltip>
                </div>
              </div>
              <!-- <div class="item">
                <img src="https://img.kakaclo.com/web-img/home/pod/icon_img2.png" alt="">
                <div class="operate f-c-c">
                  <el-tooltip effect="dark" content="Delete" placement="top">
                    <img src="https://img.kakaclo.com/web-img/home/pod/derigner/icon_3.png" alt="" class="pointer" />
                  </el-tooltip>
                  <el-tooltip effect="dark" content="Addition" placement="top">
                    <img src="https://img.kakaclo.com/web-img/home/pod/derigner/icon_4.png" alt="" class="pointer" @click="handleAdd" />
                  </el-tooltip>
                </div>
              </div> -->
              <div class="item" style="height:0;border:0;"></div>
            </div>
            <div v-if="!materialList.length" class="empty f-c-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/empty.png" alt="">
              <div class="text">No pictures yet</div>
            </div>
          </div>
        </div>
      </div>
      <div class="derigner-main">
        <div class="main-head">
          <el-radio-group v-model="modelType">
            <el-radio-button label="front">Front</el-radio-button>
            <el-radio-button label="back" :disabled="!backClass.canvasBg">Back</el-radio-button>
          </el-radio-group>
        </div>
        <div class="derigner-box f-c-c">
          <div class="derigner-print">
            <div class="print-color f-c-c">
              <el-tooltip effect="dark" content="Color" placement="right">
                <el-color-picker v-model="setColor" @change="changeColor"></el-color-picker>
              </el-tooltip>
            </div>
            <div class="print-list">
              <div v-for="item in (modelType === 'front' ? frontClass.printList : backClass.printList)" :key="item.printId" class="item pointer" :class="{ sel: (modelType === 'front' ? frontClass.printSelId === item.printId : backClass.printSelId === item.printId) }" @click="handleSelPrint(item.printId)">
                <img class="clear" src="https://img.kakaclo.com/web-img/home/pod/derigner/icon_6.png" @click="handleDelPrint(item.printId)">
                <img :src="item.printImg" alt="">
              </div>
            </div>
            <div v-if="modelType === 'front' ? frontClass.printList.length : backClass.printList.length" class="print-clear f-c-c pointer">
              <el-tooltip effect="dark" content="Clear" placement="right">
                <img src="https://img.kakaclo.com/web-img/home/pod/derigner/icon_5.png" alt="" @click="handleClearAll">
              </el-tooltip>
            </div>
          </div>
          <template>
            <div v-show="modelType === 'front'" class="canvas-bg" :style="{ width: `${zoomNum}px`, height: `${zoomNum}px`, transform: `scale(${zoomScale})` }">
              <canvas ref="frontCanvasBg" id="frontCanvasBg" :width="zoomNum" :height="zoomNum"></canvas>
              <div class="canvas-insert" :style="{ top: `${frontClass.printRect.top}px`, left: `${frontClass.printRect.left}px`, width: `${frontClass.printRect.width}px`, height: `${frontClass.printRect.height}px` }">
                <canvas id="frontCanvasInsert" :width="frontClass.printRect.width" :height="frontClass.printRect.height"></canvas>
              </div>
            </div>
            <div v-show="modelType === 'back'" class="canvas-bg" :style="{ width: `${zoomNum}px`, height: `${zoomNum}px`, transform: `scale(${zoomScale})` }">
              <canvas ref="backCanvasBg" id="backCanvasBg" :width="zoomNum" :height="zoomNum"></canvas>
              <div class="canvas-insert" :style="{ top: `${backClass.printRect.top}px`, left: `${backClass.printRect.left}px`, width: `${backClass.printRect.width}px`, height: `${backClass.printRect.height}px` }">
                <canvas id="backCanvasInsert" :width="backClass.printRect.width" :height="backClass.printRect.height"></canvas>
              </div>
            </div>
          </template>
        </div>
        <!-- <div @click="create">生成</div>
        <div @click="click">删除选中的</div>
        <div style="display:none">
          <canvas id="canvas" ref="canvas" :width="zoomNum" :height="(zoomNum / this.aspect_ratio)"></canvas>
        </div> -->
        <div class="derigner-zoom f-c-c">
          <div class="text">Scaling Ratio</div>
          <el-slider v-model="slider" :step="10"></el-slider>
          <div class="text">{{ slider }}%</div>
          <!-- <el-select v-model="slider" size="small" placeholder="请选择">
            <el-option label="0%" :value="0"></el-option>
            <el-option label="25%" :value="25"></el-option>
            <el-option label="50%" :value="50"></el-option>
            <el-option label="75%" :value="75"></el-option>
            <el-option label="100%" :value="100"></el-option>
          </el-select> -->
        </div>
        <div class="derigner-hint f--c"><i class="el-icon-warning"></i><span>{{ $t('userDesign.Tips3') }}</span></div>
      </div>
      <div class="derigner-effect f--c">
        <div v-show="frontClass.canvasBg" class="effect f-c-c">
          <div class="effect-canvas" :style="{ width: `${zoomNum}px`, height: `${zoomNum}px`, transform: `scale(0.284)` }">
            <canvas id="frontPreviewBg" :width="zoomNum" :height="zoomNum"></canvas>
            <div class="canvas-print" :style="{ top: `${frontClass.printRect.top}px`, left: `${frontClass.printRect.left}px`, width: `${frontClass.printRect.width}px`, height: `${frontClass.printRect.height}px` }"><canvas id="frontPreviewPrint" :width="frontClass.printRect.width" :height="frontClass.printRect.height"></canvas></div>
          </div>
          <!-- <div class="preview" ref="preview"></div> -->
          <div class="text">Front View</div>
        </div>
        <div v-show="backClass.canvasBg" class="effect f-c-c">
          <div class="effect-canvas" :style="{ width: `${zoomNum}px`, height: `${zoomNum}px`, transform: `scale(0.284)` }">
            <canvas id="backPreviewBg" :width="zoomNum" :height="zoomNum"></canvas>
            <div class="canvas-print" :style="{ top: `${backClass.printRect.top}px`, left: `${backClass.printRect.left}px`, width: `${backClass.printRect.width}px`, height: `${backClass.printRect.height}px` }"><canvas id="backPreviewPrint" :width="backClass.printRect.width" :height="backClass.printRect.height"></canvas></div>
          </div>
          <!-- <div class="preview"></div> -->
          <div class="text">Back View</div>
        </div>
      </div>
    </div>
    <div style="display:none">
      <canvas id="frontCreateImg" :width="zoomNum" :height="zoomNum"></canvas>
      <canvas id="backCreateImg" :width="zoomNum" :height="zoomNum"></canvas>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="360px" :before-close="handleClose" :closeOnClickModal="false">
      <div class="dialog-msg f-c-c">
        <img src="http://img.kakaclo.com/web-img/home/success.png" alt="">
        <div>Success!</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="jumpMyDesign">View My Design</el-button>
        <el-button style="margin-top:12px" @click="handleClose">continue design</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/fabric.js/2.2.3/fabric.js"></script>

<script>
import Photograph from '../../../index/components/Photograph.vue'
import API from '@/api'
import _ from 'lodash'
import { set } from 'vue'
const frontClass = {
  canvas: null,  // 最后生成的画布
  canvasBg: null, // 背景画布
  canvasPrint: null, // 印花画布
  printRect: {}, // 印花区域信息
  printList: [], // 插入的印花列表
  printSelId: '', // 选中的印花
  // color: '', // 图片颜色
  savePicture: '', // 最后生成好的图片路径
}
const backClass = {
  canvas: null,
  canvasBg: null,
  canvasPrint: null,
  printRect: {},
  printList: [],
  printSelId: '',
  // color: '',
  savePicture: ''
}
export default {
  components: { Photograph },
  data() {
    return {
      loading: false,
      operateSel: 'Version',
      draftPodModel: '', // 草稿模板
      operateList: [
        { icon: 'https://img.kakaclo.com/web-img/home/pod/derigner/icon_1.png', name: 'Version' },
        { icon: 'https://img.kakaclo.com/web-img/home/pod/derigner/icon_2.png', name: 'Upload' }
      ],
      setColor: '',
      slider: 40,
      frontClass: _.cloneDeep(frontClass),
      backClass: _.cloneDeep(backClass),
      modelType: 'front',
      productName: '',
      listParams: {
        pageSize: 20,
        pageNumber: 1,
        getDesignAreaContent: true
      },
      modelList: [],
      total: 0,
      selModel: {},
      materialList: [], // 素材图片列表
      saveLoading: false,

      json: "{\"frontImg\":{\"version\":\"5.3.0\",\"objects\":[{\"type\":\"rect\",\"version\":\"5.3.0\",\"originX\":\"left\",\"originY\":\"top\",\"left\":159,\"top\":106,\"width\":200,\"height\":300,\"fill\":\"transparent\",\"stroke\":\"#666\",\"strokeWidth\":3,\"strokeDashArray\":[10,8],\"strokeLineCap\":\"butt\",\"strokeDashOffset\":0,\"strokeLineJoin\":\"miter\",\"strokeUniform\":false,\"strokeMiterLimit\":4,\"scaleX\":0.96,\"scaleY\":1.18,\"angle\":0,\"flipX\":false,\"flipY\":false,\"opacity\":1,\"shadow\":null,\"visible\":true,\"backgroundColor\":\"\",\"fillRule\":\"nonzero\",\"paintFirst\":\"fill\",\"globalCompositeOperation\":\"source-over\",\"skewX\":0,\"skewY\":0,\"rx\":0,\"ry\":0}],\"backgroundImage\":{\"type\":\"image\",\"version\":\"5.3.0\",\"originX\":\"left\",\"originY\":\"top\",\"left\":0,\"top\":0,\"width\":1000,\"height\":1000,\"fill\":\"rgb(0,0,0)\",\"stroke\":null,\"strokeWidth\":0,\"strokeDashArray\":null,\"strokeLineCap\":\"butt\",\"strokeDashOffset\":0,\"strokeLineJoin\":\"miter\",\"strokeUniform\":false,\"strokeMiterLimit\":4,\"scaleX\":0.5,\"scaleY\":0.5,\"angle\":0,\"flipX\":false,\"flipY\":false,\"opacity\":1,\"shadow\":null,\"visible\":true,\"backgroundColor\":\"\",\"fillRule\":\"nonzero\",\"paintFirst\":\"fill\",\"globalCompositeOperation\":\"source-over\",\"skewX\":0,\"skewY\":0,\"cropX\":0,\"cropY\":0,\"src\":\"https://oss-pubilc.kakaclo.com/images/common/custom/images/20240325/14d9092f-1513-4cdc-be8d-141164ebec49.png\",\"crossOrigin\":null,\"filters\":[]}},\"backImg\":{\"version\":\"5.3.0\",\"objects\":[{\"type\":\"rect\",\"version\":\"5.3.0\",\"originX\":\"left\",\"originY\":\"top\",\"left\":149,\"top\":82.16,\"width\":200,\"height\":300,\"fill\":\"transparent\",\"stroke\":\"#666\",\"strokeWidth\":3,\"strokeDashArray\":[10,8],\"strokeLineCap\":\"butt\",\"strokeDashOffset\":0,\"strokeLineJoin\":\"miter\",\"strokeUniform\":false,\"strokeMiterLimit\":4,\"scaleX\":1,\"scaleY\":1.27,\"angle\":0,\"flipX\":false,\"flipY\":false,\"opacity\":1,\"shadow\":null,\"visible\":true,\"backgroundColor\":\"\",\"fillRule\":\"nonzero\",\"paintFirst\":\"fill\",\"globalCompositeOperation\":\"source-over\",\"skewX\":0,\"skewY\":0,\"rx\":0,\"ry\":0}],\"backgroundImage\":{\"type\":\"image\",\"version\":\"5.3.0\",\"originX\":\"left\",\"originY\":\"top\",\"left\":0,\"top\":0,\"width\":750,\"height\":750,\"fill\":\"rgb(0,0,0)\",\"stroke\":null,\"strokeWidth\":0,\"strokeDashArray\":null,\"strokeLineCap\":\"butt\",\"strokeDashOffset\":0,\"strokeLineJoin\":\"miter\",\"strokeUniform\":false,\"strokeMiterLimit\":4,\"scaleX\":0.67,\"scaleY\":0.67,\"angle\":0,\"flipX\":false,\"flipY\":false,\"opacity\":1,\"shadow\":null,\"visible\":true,\"backgroundColor\":\"\",\"fillRule\":\"nonzero\",\"paintFirst\":\"fill\",\"globalCompositeOperation\":\"source-over\",\"skewX\":0,\"skewY\":0,\"cropX\":0,\"cropY\":0,\"src\":\"https://oss-pubilc.kakaclo.com/images/common/custom/images/20240329/60722b25-a453-4f23-8ad1-3d88e73c0912.png\",\"crossOrigin\":null,\"filters\":[]}}}",
      canvas: null,

      dialogVisible: false,
    }
  },
  created() {
    if (localStorage.getItem('draftPodModel')) {
      this.draftPodModel = JSON.parse(localStorage.getItem('draftPodModel'))
    }
    if (this.userId) {
      this.getUserCustomImages()
    } else {
      // 初始化草稿数据
      // this.initDraft()
    }
  },
  mounted() {
    if (this.$route.query.modelCode) {
      this.$set(this.listParams, 'searchContent', this.$route.query.modelCode)
    }
    this.getCustomModels()
  },
  computed: {
    zoomNum() {
      // let minWidth = 300
      // return (this.slider * 10) + minWidth
      return 1000
    },
    zoomScale() {
      let min = 0.3
      return (this.slider / 100) + min
    },
    // setColor: {
    //   get() {
    //     return this[`${this.modelType}Class`].color
    //   },
    //   set(value) {
    //     this[`${this.modelType}Class`].color = value
    //   }
    // },
    userId() {
      return this.$store.state.common.userId
    }
  },
  methods: {
    uploadSuccess(imgUrl, file) {
      let name = file.name.split('.');
      name.pop() // 去除最后一个元素（即后缀）
      let img = {
        imageUrl: imgUrl,
        imageName: name.join('.'),
        type: 'local'
      }
      this.materialList.push(img)
      if (this.userId) {
        API.addUserCustomImages({
          images: [img]
        }).then(res => {
          this.getUserCustomImages()
        })
      } else {
        // localStorage.setItem('podUserMaterial', JSON.stringify(this.materialList))
      }
    },

    // 获取用户素材图片
    getUserCustomImages() {
      API.getUserCustomImages().then(res => {
        this.materialList = res.data
      })
    },

    // 获取素材列表
    getCustomModels(isInit) {
      API.getCustomModels(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.modelList = res.data.list
        this.total = res.data.total
        if (!this.selModel.id && this.draftPodModel) {
          this.initDraft()
        } else if (!this.selModel.id) {
          this.changeModel(res.data.list[0].id)
        } else if (this.selModel.id && isInit === 'init') {
          this.changeModel(this.selModel.id, isInit)
        }
      })
    },

    // 切换分页
    changePage(e) {
      this.listParams.pageNumber = e
      this.getCustomModels()
    },

    // 切换版型
    changeModel(id, isInit) {
      if (isInit === 'change') {
        if (id === this.selModel.id) return
        this.$confirm('The design result has not been saved. Are you sure you want to switch styles?', 'Prompt Message', {
          confirmButtonText: this.$t('userDesign.Confirm'),
          cancelButtonText: this.$t('userDesign.Cancel'),
          type: '',
          closeOnClickModal: false
        }).then(() => {
          this.selModel = this.modelList.find(item => item.id === id)
          this.init(isInit)
        })
        return
      }
      if (this.modelList.find(item => item.id === id)) {
        this.selModel = this.modelList.find(item => item.id === id)
        this.init(isInit)
      }
    },

    initDraft() {
      this.$confirm('The product you designed has not been saved. Do you want to continue designing?', 'Prompt Message', {
        confirmButtonText: 'Continue Designing',
        cancelButtonText: 'Redesign',
        type: '',
        closeOnClickModal: false
      }).then(() => {
        if (this.draftPodModel) {
          this.frontClass = this.draftPodModel.frontClass
          this.backClass = this.draftPodModel.backClass
          this.selModel = this.draftPodModel.selModel
          this.setColor = this.draftPodModel.setColor
        }
        let podUserMaterial = localStorage.getItem('podUserMaterial')
        if (podUserMaterial) {
          this.materialList = this.materialList.concat(JSON.parse(podUserMaterial))
          this.userId && API.addUserCustomImages({
            images: this.materialList
          }).then(res => {
            this.getUserCustomImages()
          })
        }
        this.$set(this.listParams, 'searchContent', this.selModel.modelCode)
        this.getCustomModels('init')
        localStorage.removeItem('podUserMaterial')
        localStorage.removeItem('draftPodModel')
      }).catch(() => {
        localStorage.removeItem('podUserMaterial')
        localStorage.removeItem('draftPodModel')
        this.draftPodModel = ''
        this.changeModel(this.modelList[0].id)
      })
    },

    init(isInit) {
      this.productName = this.draftPodModel ? this.draftPodModel.productName : this.selModel.enName
      if (isInit === 'change') this.productName =  this.selModel.enName
      // if (!this.draftPodModel && isInit) {
      //   this.reset()
      // }
      if (isInit === 'change' || isInit === 'clear') {
        this.reset()
      }
      this.loading = true
      this.modelType = 'front'
      this.json = JSON.parse(this.selModel.designAreaContent)
      if (this.json.frontImg) {
        this.countInserCanvasSize('frontClass', this.json.frontImg)
      }
      if (this.json.backImg) {
        this.countInserCanvasSize('backClass', this.json.backImg)
      }
      this.$nextTick(() => {
        if (this.frontClass.printRect.bgImage) {
          this.initCanvas('front')
        }
        if (this.backClass.printRect.bgImage) {
          this.initCanvas('back')
        }
        if (isInit === 'init') {
          setTimeout(() => {
            this.handleAdd({ imageUrl:'https://img.kakaclo.com/web-img/home/pod/derigner/i-con_4.png' }, 'front', 'auto')
            this.backClass.canvasPrint && this.handleAdd({ imageUrl:'https://img.kakaclo.com/web-img/home/pod/derigner/i-con_4.png' }, 'back', 'auto')
          }, 1300)
          setTimeout(() => {
            this.handleDelPrint(this.frontClass.printList[this.frontClass.printList.length-1].printId)
            this.backClass.canvasPrint && this.handleDelPrint(this.backClass.printList[this.backClass.printList.length-1].printId, 'back')
          }, 1360)
        }
        setTimeout(() => {
          this.updatePreview('all')
        },1500)
        setTimeout(() => {
          this.loading = false
        },1800)
      })
    },

    reset() {
      if (this.frontClass.canvasPrint) {
        this.frontClass.canvasPrint.clear()
        this.frontClass.canvasPrint.dispose()
        // this.frontClass.canvasPrint.requestRenderAll()
      }
      if (this.backClass.canvasPrint) {
        this.backClass.canvasPrint.clear()
        this.backClass.canvasPrint.dispose()
        // this.backClass.canvasPrint.requestRenderAll()
      }
      this.setColor = ''
      this.frontClass = _.cloneDeep(frontClass)
      this.backClass = _.cloneDeep(backClass)
    },

    // 计算插入画布的大小
    countInserCanvasSize(type, canvas) {
      let rect = canvas.objects[0]
      let printRect = {
        width: parseFloat((rect.width * rect.scaleX * (this.zoomNum/500)).toFixed(2)),
        height: parseFloat((rect.height * rect.scaleY * (this.zoomNum/500)).toFixed(2)),
        top:  parseFloat((rect.top * (this.zoomNum/500)).toFixed(2)),
        left: parseFloat((rect.left * (this.zoomNum/500)).toFixed(2)),
        rect,
        bgImage: canvas.backgroundImage
      }
      this.$set(this[type], 'printRect', printRect)
    },

    // 删除素材图片
    handleDelMaterial(item) {
      let f_list = this.frontClass.printList.map(t => t.printImg)
      let b_list = this.backClass.printList.map(t => t.printImg)
      let list = _.uniq(f_list.concat(b_list))

      if (list.includes(item.imageUrl)) {
        return this.$message.warning('The design has been added to this material and cannot be deleted!')
      }
      if (this.userId) {
        API.delUserCustomImages({
          ids: [item.id]
        }).then(res => {
          this.$message.success(res.message)
          this.getUserCustomImages()
        })
      } else {
        let index = this.materialList.findIndex(t => t.id === item.id)
        index > -1 && this.materialList.splice(index, 1)
        localStorage.setItem('podUserMaterial', JSON.stringify(this.materialList))
      }
    },
    // 添加印花
    handleAdd(item, type1, isAuto) {
      let _this = this
      let type = `${type1||this.modelType}Class`
      let canvas = this[type].canvasPrint
      let printList = this[type].printList
      if (printList.length >= 6) {
        return this.$message.warning('Insert up to 6 prints')
      }
      new fabric.Image.fromURL(item.imageUrl,
        function (img) {
          canvas.add(
            img.set({
              left: (canvas.width - (img.width * 0.8)) / 2,
              top: (canvas.height - img.height * 0.8) / 2,
              // printId: `m${printList.length}_p${printList.length + 1}`,
              printId: printList.length,
              printImg: item.imageUrl,
              printName: item.imageName,
              selectable: true,
            }).scale(0.8)
          )
          // 为图片添加选中事件的监听器
          if (!isAuto) {
            img.on('selected', function(e) {
              _this[type].printSelId = e.target.printId
              _this.updatePreview()
            })
            _this[type].printSelId = printList.length-1 // `m${printList.length-1}_p${printList.length}`
            _this[type].canvasPrint.setActiveObject(img)
          }
        },
        { crossOrigin: "anonymous" }
      )
      canvas._objects.forEach((t, i) => t.printId = i)
      this[type].canvasPrint = canvas
      this[type].printList = canvas._objects
    },

    // 切换颜色
    changeColor() {
      let frontCanvasBg = this.frontClass.canvasBg // new fabric.Canvas(`frontCanvasBg`);
      this.frontClass.canvasBg = this.setBgImage('front', frontCanvasBg)
      if (this.backClass.canvasBg) {
        let backCanvasBg = this.backClass.canvasBg // new fabric.Canvas(`backCanvasBg`);
        this.backClass.canvasBg = this.setBgImage('back', backCanvasBg)
      }
      this.updatePreview('all')
    },
    // 设置背景图片
    setBgImage(type, canvasBg) {
      let bgImage = this[`${type}Class`].printRect.bgImage
      let duotoneFilter = new fabric.Image.filters.Composed({
        subFilters: [
          new fabric.Image.filters.Grayscale({ mode: 'luminosity' }), // make it black and white
          new fabric.Image.filters.BlendColor({ color: this.setColor }), // apply light color
          // new fabric.Image.filters.BlendColor({ color: '#23278a', mode: 'lighten' }), // apply a darker color
        ]
      })
      // 设置背景图片（从URL）
      fabric.Image.fromURL(bgImage.src, (img) => {
        // 颜色调整
        if (this.setColor) {
          img.filters = [duotoneFilter]
          img.applyFilters();
        }
        // 设置背景图像的宽度和高度，以匹配画布
        // // 将图像设置为背景图像
        canvasBg.setBackgroundImage(img,
          canvasBg.renderAll.bind(canvasBg), // 刷新画布
          { //保证背景图1:1铺满容器
          scaleX: canvasBg.width / img.width, //计算出图片要拉伸的宽度
          scaleY: canvasBg.width / img.width //计算出图片要拉伸的高度
          }
        )
      }, { crossOrigin: "anonymous" });
      return canvasBg
    },

    // 选中图片元素
    handleSelPrint(printId) {
      let type = `${this.modelType}Class`
      this[type].printList.forEach(t => {
        if (t.printId === printId) {
          this[type].printSelId = printId
          this[type].canvasPrint.setActiveObject(t)
        }
      })
      this[type].canvasPrint.renderAll(); // 确保渲染所有对象
    },
    // 删除图片元素
    handleDelPrint(printId, type1) {
      let type = `${type1||this.modelType}Class`
      let img = this[type].printList.find(t => t.printId === printId)
      this[type].canvasPrint.remove(img)
      if (printId === this[type].printSelId) {
        this[type].printSelId = ''
      }
      this.updatePreview()
    },
    // 删除画布所有元素
    handleClearAll() {
      let type = `${this.modelType}Class`
      this[type].printSelId = ''
      this[type].canvasPrint.clear();
      this[type].canvasPrint.requestRenderAll();
      this[type].printList = []
      this.updatePreview()
    },

    // 初始化画布
    initCanvas(type) {
      let _this = this
      let canvasBg = new fabric.Canvas(`${type}CanvasBg`);
      canvasBg.setDimensions({ width: this.zoomNum, height: this.zoomNum });
      // 设置背景
      this[`${type}Class`].canvasBg = this.setBgImage(type, canvasBg)

      let canvasInsert = new fabric.Canvas(`${type}CanvasInsert`);
      if (this.draftPodModel) {
        canvasInsert.loadFromJSON(this[`${type}Class`].canvasPrint, function() {
        // 回调函数确保所有对象都被加载到画布上后执行
          let objects = canvasInsert.getObjects()
          objects.forEach((t, i) => {
            t.printImg = t.src,
            t.printName = _this.materialList[_this.materialList.findIndex(k => t.src === k.imageUrl)].imageName,
            t.printId = i // `m${i}_p${i+1}`
            // 为图片添加选中事件的监听器
            t.on('selected', function(e) {
              _this[`${type}Class`].printSelId = e.target.printId
              _this.updatePreview()
            })
            if (_this[`${type}Class`].printSelId === i) {
              canvasInsert.setActiveObject(t)
            }
          })
          _this.$set(_this[`${type}Class`], 'printList', _.cloneDeep(objects))
          canvasInsert.renderAll()
        })
      }
      this[`${type}Class`].canvasPrint = canvasInsert

      // 画布元素添加
      canvasInsert.on('object:added', function(e) {
        _this.updatePreview()
      });
      // 监听图片的移动事件
      canvasInsert.on('object:moving', function(e) {
        _.debounce(() => {
          _this.updatePreview()
        }, 1000)
      });
      // 监听图片的缩放事件
      canvasInsert.on('object:scaling', function(e) {
        _.debounce(() => {
          _this.updatePreview()
        }, 1000)
      });
      // 监听图片的旋转事件
      canvasInsert.on('object:modified', function(e) {
        _this.updatePreview()
      });
    },

    // 更新预览
    updatePreview (isAll) {
      if (this.frontClass.canvasPrint && (isAll || this.modelType === 'front')) {
        this.upDatePreviewCanvas('front')
      }
      if (this.backClass.canvasPrint && (isAll || this.modelType === 'back')) {
        this.upDatePreviewCanvas('back')
      }
    },
    // 更新画布视图
    upDatePreviewCanvas(type) {
      let operateCanvasPrint = this[`${type}Class`].canvasPrint
      let canvasBg = new fabric.Canvas(`${type}PreviewBg`)
      let canvasPrint = new fabric.StaticCanvas(`${type}PreviewPrint`) // StaticCanvas: （一个静态不可交互的画布）
      canvasBg.setDimensions({ width: this.zoomNum, height: this.zoomNum });
      canvasPrint.setDimensions({ width: this[`${type}Class`].printRect.width, height: this[`${type}Class`].printRect.height });

      // 设置背景
      this.setBgImage(type, canvasBg)

      let objects = operateCanvasPrint.getObjects()
      if (this[`${type}Class`].printSelId || this[`${type}Class`].printSelId === 0) {
        let top = objects.splice(objects.findIndex(t => this[`${type}Class`].printSelId === t.printId), 1)
        objects = objects.concat(top)
      }
      objects.forEach((img) => {
        let cloneImg = _.cloneDeep(img)
        cloneImg.left = cloneImg.left // + this.frontClass.printRect.left
        cloneImg.top = cloneImg.top // + this.frontClass.printRect.top
        canvasPrint.add(cloneImg)
      })
    },

    // 保存
    save() {
      if (!this.productName) {
        return this.$message.warning('Please input the product name')
      }
      if (this.productName.length > 100) {
        return this.$message.warning('Product name cannot exceed 100 characters')
      }
      if (!this.userId) {
        this.saveLoading = true
        localStorage.setItem('draftPodModel', JSON.stringify({
          frontClass: {
            ...this.frontClass,
            canvasBg: this.frontClass.canvasBg && this.frontClass.canvasBg.toJSON(),
            canvasPrint: this.frontClass.canvasPrint && this.frontClass.canvasPrint.toJSON(),
          },
          backClass: {
            ...this.backClass,
            canvasBg: this.backClass.canvasBg && this.backClass.canvasBg.toJSON(),
            canvasPrint: this.backClass.canvasPrint && this.backClass.canvasPrint.toJSON(),
          },
          selModel: this.selModel,
          setColor: this.setColor,
          productName: this.productName
        }))
        localStorage.setItem('podUserMaterial', JSON.stringify(this.materialList))
        localStorage.setItem('loginRedirection', JSON.stringify({
          path: this.$route.path,
          query: this.$route.query,
        }))
        location.href = '/login'
        return
      }
      const h = this.$createElement;
      this.$confirm(
        h('div', null, [
          h('p', null, 'In order to ensure that the designed product is consistent with the purchased product, no modification will be allowed after saving the design!'),
          h('p', { style: 'margin-top: 10px' }, 'Are you sure the current design is complete?')
        ]), 'Prompt Message', {
        confirmButtonText: this.$t('userDesign.Confirm'),
        cancelButtonText: this.$t('userDesign.Cancel'),
        type: '',
        closeOnClickModal: false
      }).then(() => {
        this.saveLoading = true
        this.loading = true
        if (this.frontClass.canvasPrint) {
          this.createImg('front')
        }
      })
      // if (this.backClass.canvasPrint) {
      //   this.createImg('back')
      // }
      // setTimeout() {}
      // this.saveDesignedProduct()
    },
    // 合并画布生成图片
    createImg(type) {
      let canvas = new fabric.Canvas(`${type}CreateImg`)
      // 设置背景
      this[`${this.modelType}Class`].canvasBg = this.setBgImage(type, canvas)

      let operateCanvasPrint = this[`${type}Class`].canvasPrint
      // let objects = operateCanvasPrint.getObjects()
      // objects.forEach((img) => {
      //   let cloneImg = _.cloneDeep(img)
      //   cloneImg.left = cloneImg.left + this[`${type}Class`].printRect.left
      //   cloneImg.top = cloneImg.top + this[`${type}Class`].printRect.top
      //   canvas.add(cloneImg)
      // })
      let canvas2Image = new fabric.Image(operateCanvasPrint.toCanvasElement(), {
        left: this[`${type}Class`].printRect.left, // 根据需要调整位置
        top: this[`${type}Class`].printRect.top // 根据需要调整位置
      });
      canvas.add(canvas2Image);

      setTimeout(() => {
        let img = canvas.toDataURL({
          width: canvas.width,
          height: canvas.height,
          format: 'png',
          quality: 1
        })
        // let image = new Image()
        // image.src = img
        // document.body.appendChild(image)
        this.uploadPicture(img, type)
      }, 1000)
    },

    // base64转文件
    convertFile(base64Data, filename) {
      let arr = base64Data.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime === 'image/webp' ? 'image/jpeg' : mime })
    },
    // 上传图片
    uploadPicture(base64Data, type) {
      API.customProductGetSignValue({ directory: 'common/custom/images/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'common/custom/images/')
        formData.append('signValue', data)
        formData.append('fileList', this.convertFile(base64Data))
        API.customProductUploadFile(formData).then((res) => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this[`${type}Class`].savePicture = res.data
          if (this.backClass.canvasPrint && !this.backClass.savePicture) {
            this.createImg('back')
          } else {
            this.saveDesignedProduct()
          }
        })
      }).catch(() => {
        this.saveLoading = false
        this.loading = false
      })
      // .finally(() => {
      //   this.saveLoading = false
      //   this.loading = false
      // })
    },
    saveDesignedProduct() {
      // if (this.frontClass.canvasPrint && !this.frontClass.savePicture) {
      //   return
      // }
      // if (this.backClass.canvasPrint && !this.backClass.savePicture) {
      //   return
      // }
      let f_list = this.frontClass.printList.map(t => ({ imageName: t.printName, imageUrl: t.printImg }))
      let b_list = this.backClass.printList.map(t => ({ imageName: t.printName, imageUrl: t.printImg }))
      let materialImages = _.uniqBy(f_list.concat(b_list), 'imageUrl')
      API.saveDesignedProduct({
        modelId: this.selModel.modelId,
        enName: this.productName,
        imageUrl: this.frontClass.savePicture || undefined,
        backImageUrl: this.backClass.savePicture || undefined,
        materialImages,
        colorValue: this.setColor
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.dialogVisible = true
      }).finally(() => {
        this.saveLoading = false
        this.loading = false
      })
    },

    jumpList() {
      location.href = `/podModel-list`
    },

    handleClose() {
      this.dialogVisible = false
      this.draftPodModel = ''
      this.init('clear')
    },

    jumpMyDesign() {
      location.href = `/publish/userDesign`
    }
  }
}
</script>

<style lang="scss" scoped>
.pod-derigner {
  background-color: #fff;
  color: #303133;
  min-width: 1200px;
  overflow: hidden;

  button, input {
    border-radius: 2px !important;
  }
  img {
    display: block;
  }
  div {
    box-sizing: border-box;
  }

  .pod-derigner-head {
    height: 64px;
    padding: 0 24px;
    border-bottom: 1px solid #E1E4EA;
    .left {
      width: 30%;
    }
    .name {
      width: 40%;
      .text {
        flex-shrink: 0;
        margin-right: 12px;
      }
      /deep/ input {
        border-radius: 2px;
      }
    }
    .right {
      width: 30%;
      display: flex;
      justify-content: flex-end;
    }
  }

  .derigner-content {
    position: relative;
    width: 100%;
    height: calc(100vh - 64px);
    background-color: #f5f7f7;
    // min-height: 1000px;
    // overflow: auto;

    .derigner-model {
      position: absolute;
      z-index: 100;
      background-color: #fff;
      height: calc(100vh - 65px);
      .model-operation {
        width: 80px;
        height: 100%;
        border-right: 1px solid #EFF1F7;
        .operation-item {
          width: 100%;
          height: 82px;
          flex-direction: column;
          >img {
            width: 24px;
            height: 24px;
            margin-bottom: 4px;
          }
        }
        .sel {
          background-color: #F7FCEB;
          border-left: 3px solid #9AC331;
        }
      }

      .model-list {
        width: 332px;
        height: 100%;
        padding: 20px 18px 20px 20px;
        border-right: 1px solid #E1E4EA;
        /deep/ input {
          border-radius: 2px;
        }
        .list {
          margin-top: 20px;
          padding-right: 6px;
          flex-wrap: wrap;
          max-height: calc(100vh - 200px);
          overflow: auto;
          .item {
            width: 134px;
            color: #606266;
            font-size: 12px;
            padding-bottom: 12px;
            .img {
              width: 100%;
              height: 134px;
              border: 1px solid #E1E4EA;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .sel {
              border: 1px solid #9AC331;
            }
            .code {
              text-align: center;
              margin: 4px 0 2px;
            }
          }
        }
        ::-webkit-scrollbar {
          width: 6px !important;
        }
        .paging {
          width: 100%;
          margin-top: 20px;
          >div {
            display: flex;
            justify-content: center;
          }
          /deep/ .el-pager {
            li {
              padding: 0 8px
            }
          }
        }
      }

      .model-material {
        width: 332px;
        height: 100%;
        padding: 20px;

        .upload-img {
          width: 100%;
          height: 126px;
          border: 1px dashed #E1E4EA;
          background-color: #F7F8FB;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #909399;
          /deep/ .upload {
            img {
              width: 50px;
              height: 50px;
            }
          }
        }
        .meterial {
          margin-top: 40px;
          .list {
            max-height: calc(100vh - 360px);
            overflow: auto;
            flex-wrap: wrap;
            margin-top: 20px;
            padding-right: 4px;
            .item {
              width: 90px;
              height: 90px;
              margin-bottom: 12px;
              border: 1px solid #E1E4EA;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .operate {
                display: none;
                position: absolute;
                width: 100%;
                height: 24px;
                background: rgba($color: #333, $alpha: 0.6);
                bottom: 0;
                img {
                  width: 17px;
                  height: 17px;
                  margin: 0 6px;
                }
              }
            }
            .item:hover {
              .operate {
                display: flex !important;
              }
            }
          }
          ::-webkit-scrollbar {
            width: 6px !important;
          }
          .empty {
            flex-direction: column;
            padding: 24px;
            img {
              width: 120px;
              height: 120px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }

    .derigner-main {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      width: calc(100vw - 680px);
      min-width: 520px;
      height: 1100px;
      display: flex;
      align-items: flex-end;
      flex-direction: column;

      .main-head {
        width: calc(100% - 92px);
        height: 32px;
        margin: 20px 0 12px 0;
        /deep/ .el-radio-button__inner{
          padding: 0 16px;
          height: 32px;
          line-height: 32px;
          font-size: 13px;
        }
      }

      .derigner-box {
        width: calc(100% - 92px);
        min-height: 600px;
        height: calc(100vh - 200px);
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #fff;
        position: relative;
        .derigner-print {
          position: absolute;
          top: 0;
          left: 0;
          width: 72px;
          padding: 20px 12px;
          z-index: 100;
          .print-list {
            flex-direction: column;
          }
          .item {
            width: 100%;
            height: 48px;
            border: 1px solid #E1E4EA;
            border-radius: 2px;
            margin-bottom: 8px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .clear {
              position: absolute;
              width: 16px;
              height: 16px;
              right: -6px;
              top: -6px;
            }
          }
          .print-color {
            flex-direction: column;
            margin-bottom: 30px;
            width: 100%;
            border: 0;
            /deep/ .el-color-picker {
              width: 100%;
              height: 48px;
              .el-color-picker__trigger {
                width: 100%;
                height: 100%;
              }
            }
          }
          .sel {
            border: 1px solid #9AC331;
          }
          .print-clear {
            img {
              width: 24px;
              height: 24px;
            }
          }
        }

        .canvas-bg {
          position: absolute;
          .canvas-insert {
            z-index: 10;
            position: absolute;
            border: 2px dashed #555;
          }
        }
      }
      .derigner-zoom {
        width: calc(100% - 92px);
        height: 70px;
        border-top: 1px solid #E1E4EA;
        background-color: #fff;
        .el-slider {
          width: 240px;
          margin: 0 12px;
        }
        /deep/ .el-select {
          width: 88px;
          input {
            border-radius: 2px;
          }
        }
      }
      .derigner-hint {
        width: calc(100% - 92px);
        margin-top: 15px;
        font-size: 12px;
        color: #909399;
        i {
          color: #909399;
          font-size: 16px;
          margin-right: 4px;
        }
        span {
          position: relative;
          top: 1px;
        }
      }
    }

    .derigner-effect {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      width: 320px;
      height: calc(100vh - 65px);
      border-left: 1px solid #E1E4EA;
      background-color: #fff;
      flex-direction: column;
      .effect {
        width: 280px;
        height: 330px;
        position: relative;
        .preview {
          width: 280px;
          height: 280px;
          border: 1px solid #888;
        }
        .effect-canvas {
          position: absolute;
          border: 1px solid #888;
          .canvas-print {
            position: absolute;
          }
        }
        .text {
          color: #909399;
          text-align: center;
          margin-top: 8px;
          position: absolute;
          bottom: 0;
        }
      }
    }

  }

  .dialog-msg {
    width: 100%;
    flex-direction: column;
    color: #606266;
    font-size: 13px;
    img {
      width: 64px;
      height: 64px;
      margin-bottom: 8px;
    }
  }
  .dialog-footer {
    button {
      width: 100%;
      margin: 0;
    }
  }

}
</style>
